import React, { Component } from 'react';
import { View, TouchableOpacity } from 'react-native';
import Text from '@dbk/ui-text';
import { ChevronDown, CloseIcon, Profile } from '@dbk/ui-icons';
import { PALETTE, ROUTES, ArrowRight } from '../../../constants';
import DisplayTime from '../messenger/get-display-time';


// import styles from './styles';
class ContactItem extends Component {

  // componentDidMount()
  render = () => (
    <div className="contact-item" onClick={this.props.onClick}>


      <Profile color={PALETTE.secondaryText} className="profile-icon" height={30} width={30} />
      {this.props.online &&
        <div className="online" />
      }


      <div className="profile-info">
        <div className="userDetailsRow">
         <span style={{float: 'left'}}>
           <Text className="contactName" numberOfLines={1}
            ellipsizeMode={'tail'}
            style={
              [{  overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }]}>
            {this.props.name ? this.props.name : ''}
          </Text>
          </span>
          <span style={{float: 'right'}}>
          <Text className="userListTimestamp" >
            <DisplayTime
              dateAndTime={this.props.timestamp} /></Text>
          </span>
        </div>

        <div className="message"  >{this.props.message ? this.props.message : ''}</div>
      </div>




      <ChevronDown width={10} height={10} color={PALETTE.secondaryText} className="right-icon " />
    </div>

  )
  // constructor(props) { super(props); }
  // componentWillMount() {}
  // componentWillReceiveProps(){}
  // shouldComponentUpdate(){}
  // componentWillUpdate(){}
  // componentDidUpdate(){}
  // componentWillUnmount(){}

}
export default ContactItem;
